import { isString, isBoolean, isNumber } from '../components/form/formUtilities';


const compareNumber = (n1, n2, asc) => {
  if (!Number.isNaN(n1) && !Number.isNaN(n1)) {
    if (n1 === n2) {
      return 0;
    }
    let comp = 0;
    if (n1 > n2) {
      comp = 1;
    } else {
      comp = -1;
    }
    return comp * (asc ? 1 : -1);
  }

  if (Number.isNaN(n1) && Number.isNaN(n1)) {
    return 0;
  }

  if (Number.isNaN(n1)) {
    return 1;
  }

  return -1;
};

const compareString = (n1, n2, asc) => n1.toUpperCase().localeCompare(n2.toUpperCase()) * (asc ? 1 : -1);

const compareBoolean = (n1, n2, asc) => {
  if (n1 === n2) {
    return 0;
  }
  let comp = 0;
  if (n1) {
    comp = 1;
  } else {
    comp = -1;
  }
  return comp * (asc ? 1 : -1);
};

const compare = (a, b, asc) => {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }

  if (isNumber(a) && isNumber(b)) {
    return compareNumber(a, b, asc);
  }

  if (isString(a) && isString(b)) {
    return compareString(a, b, asc);
  }

  if (isBoolean(a) && isBoolean(b)) {
    return compareBoolean(a, b, asc);
  }
  return 0;
};

const compareRows = (sort, data, row1, row2, index) => {
  const sortDef = sort.get(index);
  const a = row1.get(sortDef.get('id'));
  const b = row2.get(sortDef.get('id'));
  const comp = compare(a, b, sortDef.get('asc'));
  const nextIndex = index + 1;
  if (comp !== 0 || sort.size === nextIndex) {
    return comp;
  }
  return compareRows(sort, data, row1, row2, nextIndex);
};

export const basicSort = (sort, data) => {
  if (!sort.size) {
    return data;
  }
  return data.sort((row1, row2) => compareRows(sort, data, row1, row2, 0));
};

export const toggleColumn = (columns, id) => {
  const index = columns.indexOf(id);

  if (index >= 0) {
    return columns.delete(index);
  }

  return columns.push(id);
};
